import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles({
  wrapper: {
    padding: '0.2rem',
    maxWidth: '78.125rem',
    margin: '0 auto',
  },
});

const Wrapper = (props) => {
  const classes = useStyles();

  return <div className={classes.wrapper} {...props} />;
};

export default Wrapper;
